// ============================================================================
// This file is PROJECT SPECIFIC
// ============================================================================

// Registration member types
const initMemberTypes = () => {
  const countrySelect = document.getElementById('user_country')
  const memberTypeSelect = document.getElementById('user_member_type_id')

  if (!countrySelect || !memberTypeSelect) return

  const isLocked = countrySelect.disabled
  const memberTypes = JSON.parse(memberTypeSelect.dataset.memberTypes || '{}')

  const updateMemberTypeOptions = () => {
    const selectedCountryCode = countrySelect.value
    const desiredValue = memberTypeSelect.dataset.selectedValue || memberTypeSelect.value

    memberTypeSelect.innerHTML = '<option value="">Please Select</option>'

    if (!selectedCountryCode) {
      memberTypeSelect.disabled = true
      memberTypeSelect.value = ''
      memberTypeSelect.dataset.selectedValue = ''
      memberTypeSelect.dispatchEvent(new Event('change'))
      return
    }

    Object.entries(memberTypes).forEach(([memberTypeName, memberTypeData]) => {
      const { id, country_rule, countries = [] } = memberTypeData
      let shouldShow = false

      switch (country_rule) {
        case 'all_countries':
          shouldShow = true
          break
        case 'specific_countries':
          shouldShow = countries.includes(selectedCountryCode)
          break
        case 'exclude_countries':
          shouldShow = !countries.includes(selectedCountryCode)
          break
      }

      if (!shouldShow) return

      const option = document.createElement('option')
      option.value = id
      option.textContent = memberTypeName
      memberTypeSelect.appendChild(option)
    })

    if (
      Array.from(memberTypeSelect.options).some((option) => option.value === String(desiredValue))
    ) {
      memberTypeSelect.value = desiredValue
    } else {
      memberTypeSelect.value = ''
    }

    memberTypeSelect.disabled = isLocked || memberTypeSelect.options.length <= 1
    memberTypeSelect.dataset.selectedValue = ''
    memberTypeSelect.dispatchEvent(new Event('change'))
  }

  countrySelect.addEventListener('change', updateMemberTypeOptions)
  updateMemberTypeOptions()
}

// Sign-up form: member types are radio cards, shown only for the chosen country
const initMemberTypeCards = () => {
  const countrySelect = document.getElementById('user_country')
  const group = document.querySelector('[data-member-type-cards]')
  if (!countrySelect || !group) return

  const cards = Array.from(group.querySelectorAll('[data-member-type-card]'))
  const emptyNote = group.querySelector('[data-member-type-empty]')

  const isOffered = (card, countryCode) => {
    const countries = JSON.parse(card.dataset.countries || '[]')
    switch (card.dataset.countryRule) {
      case 'specific_countries':
        return countries.includes(countryCode)
      case 'exclude_countries':
        return !countries.includes(countryCode)
      default:
        return true
    }
  }

  const updateCards = () => {
    const countryCode = countrySelect.value
    let shown = 0

    cards.forEach((card) => {
      const radio = card.querySelector('input[type="radio"]')
      const offered = !!countryCode && isOffered(card, countryCode)

      card.classList.toggle('hidden', !offered)
      // Disabled radios are left out of the required check and the submitted form
      radio.disabled = !offered
      if (!offered) radio.checked = false
      if (offered) shown += 1
    })

    if (emptyNote) {
      emptyNote.textContent = countryCode
        ? 'No registration categories are available for this country yet.'
        : 'Select your country to see the categories available to you.'
      emptyNote.classList.toggle('hidden', shown > 0)
    }
  }

  countrySelect.addEventListener('change', updateCards)
  updateCards()
}

const initMemberTypeUploadRequirement = () => {
  const memberTypeSelect = document.getElementById('user_member_type_id')
  const memberTypeUploadInput = document.getElementById('user_member_type_upload')
  const memberTypeUploadButton = document.querySelector('label[data-upload-button]')

  if (!memberTypeSelect || !memberTypeUploadInput) return

  const isEditMode = !!document.getElementById('current-membership')
  const exemptNames = JSON.parse(memberTypeUploadInput.dataset.exemptNames || '[]')

  if (memberTypeUploadButton) {
    memberTypeUploadButton.addEventListener('click', (e) => {
      if (memberTypeUploadButton.dataset.disabled === 'true') e.preventDefault()
    })
  }

  const updateUploadRequirement = () => {
    const selectedOption = memberTypeSelect.options[memberTypeSelect.selectedIndex]
    const selectedName = selectedOption?.text?.trim() || ''
    const applicable = selectedName.length > 0 && !exemptNames.includes(selectedName)

    memberTypeUploadInput.required = !isEditMode && applicable
    memberTypeUploadInput.disabled = !applicable

    if (memberTypeUploadButton) {
      memberTypeUploadButton.dataset.disabled = String(!applicable)
    }
  }

  memberTypeSelect.addEventListener('change', updateUploadRequirement)
  updateUploadRequirement()
}

// Initialize all custom functionality
const initRegistration = () => {
  initMemberTypes()
  initMemberTypeCards()
  initMemberTypeUploadRequirement()
}

export default initRegistration
